<div class="px-2">
  <div class="form-row row">
    <div class="col-2">
      <label class="control-label">{{'i18n.domain.administration.subscription-details.tariffs-tab.assigned-tariffs' | translate}}:</label>
    </div>
    <div class="col-10">
      @for (tariff of assignedTariffs; track tariff) {
        <div class="assigned-tariffs">
          <div>{{tariff.name}}</div>
        </div>
      }
    </div>
  </div>
</div>
